import React from 'react';
import { X } from 'lucide-react';

export function StatusModal({ open, onClose, status, onStatusChange }) {
  if (!open) return null;

  const statuses = [
    { value: 'entregado', label: 'Entregado', color: 'bg-brand-green' },
    { value: 'cancelado', label: 'Cancelado', color: 'bg-red-500' },
    { value: 'rechazado', label: 'Rechazado', color: 'bg-orange-500' }
  ];

  return (
    <div className="fixed inset-0 flex items-center justify-center p-4" style={{ zIndex: 2000 }}>
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="bg-white rounded-2xl w-full max-w-md relative">
        <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between">
          <h2 className="text-xl font-bold text-gray-900">Estado</h2>
          <button onClick={onClose} className="p-2 rounded-lg hover:bg-gray-100">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-6 space-y-3">
          {statuses.map((s) => (
            <button
              key={s.value}
              onClick={() => {
                onStatusChange(s.value);
                onClose();
              }}
              className={`w-full p-4 rounded-lg border-2 transition-all text-left ${
                status === s.value
                  ? 'border-brand-primary bg-brand-primary/5'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              <div className="flex items-center gap-3">
                <div className={`w-4 h-4 rounded-full ${s.color}`} />
                <span className="font-semibold text-gray-900">{s.label}</span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}